module.exports = __webpack_public_path__ + "assets/img/盗梦空间.1be9836a.png";